(() => {
  if (customElements.get('fa-activity-times')) return;
  customElements.define('fa-activity-times', class extends HTMLElement {
    connectedCallback() {
      const formatter = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Regina', year: 'numeric', month: 'long', day: 'numeric',
        hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
      });
      this.querySelectorAll('time[datetime]').forEach(time => {
        const date = new Date(time.dataset.cutoff || time.dateTime || time.getAttribute('datetime'));
        if (!Number.isFinite(date.getTime())) return;
        let displayDate = date;
        if (time.dataset.lastEntryMinute === 'true') {
          const clock = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'America/Regina', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
          }).formatToParts(date);
          if (clock.filter(part => ['hour', 'minute', 'second'].includes(part.type)).every(part => part.value === '00')) {
            displayDate = new Date(date.getTime() - 60000);
            time.dataset.cutoff = date.toISOString();
            time.dateTime = displayDate.toISOString();
          }
        }
        time.textContent = formatter.format(displayDate);
      });
    }
  });
})();
